import { useCallback } from "react";
import moment from "moment-timezone";
import { useCompanyPreferences } from "../../../Settings/Configuration/hooks/usePreferences";
import { useAccess } from "../../../../utils/hooks/access";

export const useRequestCutoff = () => {
    const coverageDeadline = useCompanyPreferences("requests.openShift.coverageDeadline");
    const { hasAccess: canApproveRequest } = useAccess("request.canApproveTeamRequest");
    const hours = canApproveRequest || coverageDeadline === null ? 0 : (coverageDeadline ?? 3) * 2;

    const isTooLate = useCallback((startDate: any) => {
        return moment.parseZone(startDate).isBefore(moment().add(hours, "hours"), "seconds");
    }, [hours]);

    return { hours, isTooLate };
};
